var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tgmag-btn",class:[
    _vm.buttonClasses,
    { 'tgmag-btn--loading': _vm.loading },
    { 'tgmag-btn--disabled': _vm.isDisabled }
  ],attrs:{"tabindex":"0"},on:{"click":_vm.onClick}},[_vm._t("default"),(_vm.loading)?_c('spinner',{staticClass:"tgmag-btn__spinner",attrs:{"role":"status"}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }